// ============================================================================
// /tutor/exercises/new — choix du type d'exercice (Zéro V1).
// ============================================================================
// « Exercice guidé V2 » → /tutor/exercises/new-v2 ; « Exercice fondamental »
// → `FundamentalExerciseFlow` (écrit directement en V2). L'ancien assistant
// guidé V1 (SolvePath → exercise_steps) est supprimé.
// ============================================================================

import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowLeft, Sparkles, Zap } from 'lucide-react';
import { FundamentalExerciseFlow } from '@/components/fundamental-exercise-flow';

type ExerciseKind = 'fundamental';

export function TutorExercisesNewPage() {
  const [exerciseKind, setExerciseKind] = useState<ExerciseKind | null>(null);

  if (exerciseKind === null) {
    return (
      <div className="pb-safe mx-auto max-w-3xl p-4 sm:p-6">
        <Link
          to="/tutor/exercises"
          className="text-ink-500 hover:text-ink-900 mb-5 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Mes exercices
        </Link>
        <h1 className="font-display text-ink-900 mb-2 text-[22px] font-extrabold">
          Nouvel exercice
        </h1>
        <p className="text-ink-500 mb-6 font-sans text-sm">Quel type d'exercice veux-tu créer ?</p>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Link
            to="/tutor/exercises/new-v2"
            className="border-primary-200 hover:border-primary-400 rounded-2xl border bg-white p-5 text-left transition-all hover:shadow-md active:scale-[.99]"
          >
            <div className="bg-primary-50 mb-3 flex h-11 w-11 items-center justify-center rounded-xl">
              <Sparkles className="text-primary-600 h-5 w-5" />
            </div>
            <h2 className="font-display text-ink-900 text-[15px] font-extrabold">
              Exercice guidé V2 (blocs)
            </h2>
            <p className="text-ink-500 mt-1 font-sans text-[13px]">
              Colle l'énoncé : audit de cohérence, découpage en questions courtes, corrigé,
              distracteurs et image — phase par phase.
            </p>
          </Link>
          <button
            type="button"
            onClick={() => setExerciseKind('fundamental')}
            className="border-ink-200 hover:border-primary-300 rounded-2xl border bg-white p-5 text-left transition-all hover:shadow-md active:scale-[.99]"
          >
            <div className="bg-accent-50 mb-3 flex h-11 w-11 items-center justify-center rounded-xl">
              <Zap className="text-accent-500 h-5 w-5" />
            </div>
            <h2 className="font-display text-ink-900 text-[15px] font-extrabold">
              Exercice fondamental · Source Warmup
            </h2>
            <p className="text-ink-500 mt-1 font-sans text-[13px]">
              Une banque de questions QCM indépendantes, gratuite, qui alimente le Warmup.
            </p>
          </button>
        </div>
      </div>
    );
  }

  if (exerciseKind === 'fundamental') {
    return (
      <div className="pb-safe mx-auto max-w-3xl p-4 sm:p-6">
        <button
          type="button"
          onClick={() => setExerciseKind(null)}
          className="text-ink-500 hover:text-ink-900 mb-5 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Type d'exercice
        </button>
        <h1 className="font-display text-ink-900 mb-6 text-[22px] font-extrabold">
          Nouvel exercice fondamental
        </h1>
        <FundamentalExerciseFlow />
      </div>
    );
  }

  return null;
}
